/** Wait for the rendered hero images, including cached images and failed requests. */
export async function waitForImages(root: HTMLElement, signal: AbortSignal): Promise<void> {
  const images = Array.from(root.querySelectorAll('img'));

  await Promise.all(images.map(async (image) => {
    if (signal.aborted) return;

    if (!image.complete) {
      await new Promise<void>((resolve) => {
        const finish = () => {
          image.removeEventListener('load', finish);
          image.removeEventListener('error', finish);
          signal.removeEventListener('abort', finish);
          resolve();
        };
        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', finish, { once: true });
        signal.addEventListener('abort', finish, { once: true });
        // The request may have completed between the first check and registration.
        if (image.complete || signal.aborted) finish();
      });
    }

    if (!signal.aborted && image.naturalWidth > 0 && image.decode) {
      // A failed decode must not keep the entire hero hidden.
      await image.decode().catch(() => undefined);
    }
  }));
}
